import React from 'react';
import { Modal, Box, CircularProgress } from '@mui/material';

const ConfirmExitModal = ({ show, onConfirm, onCancel, onDiscard, loading }) => {
  return (
    <Modal open={show} onClose={onCancel}>
      <Box className="bg-[color:var(--themeSurfaceColor,#FFFFFF)] p-8 rounded-xl w-[100%] max-w-lg mx-auto mt-40 shadow-lg font-[Poppins] font-medium text-center">
        <p className="text-lg text-[color:var(--themePrimaryColor,#DA6E0B)] mb-2 font-semibold">Unsaved Prescription!</p>
        <p className="text-gray-700 text-sm leading-relaxed mb-6">
          You have made changes to the prescription that haven’t been saved.
          <br /><br />
          If you leave now, your data will be lost.
          <br /><br />
          Would you like to <strong>save it as a draft</strong> before exiting?
        </p>
        <div className="flex justify-center gap-4 flex-wrap">
          <button
            onClick={onConfirm}
            className="bg-[color:var(--themePrimaryColor,#DA6E0B)] text-white px-5 py-2 rounded-lg hover:opacity-90 transition"
          >
            {loading ? <CircularProgress size={24} style={{ color: "var(--themeSurfaceColor, #FDFDFD)" }} /> :
              "💾 Save as Draft & Exit"}
          </button>
          <button
            onClick={onDiscard}
            className="bg-red-500 text-white px-5 py-2 rounded-lg hover:opacity-90 transition"
          >
            🗑 Discard & Exit
          </button>
          <button
            onClick={onCancel}
            className="bg-gray-400 text-white px-5 py-2 rounded-lg hover:opacity-90 transition"
          >
            ✖ Stay on Page
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmExitModal;
